<template>
  <!-- has to be position relative so we can place the filename label above the input -->
  <hm-col :id="$attrs['id']" :class="[$attrs['class'], gridClasses]" style="position: relative;">
    <hm-input ref="file"
              :class="['component__hm-file', 'hm-input__file', { 'hm-input__file--file-set': !isEmpty(internalValue.fileName) }]"
              :title="internalValue.fileName"
              :has-value="!isEmpty(internalValue.fileName)"
              :label="label"
              :help="help"
              :key="internalValue.fileName"
              type="file"
              cols="12"
              @change="onChangeFileUpload">
      <template slot="icon-inline-right">
        <input-icon-button v-tooltip="{ title: $t('inputs.hmInputFile.deleteFile'), delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                           :class="{ 'transparent pointer-events-none': isEmpty(internalValue.fileURL) }"
                           :border="false"
                           icon="close-text"
                           @click="deleteFile()" />
        <input-icon-button v-tooltip="{ title: $t('inputs.hmInputFile.showPreview'), delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                           :class="{ 'transparent pointer-events-none': isEmpty(internalValue.fileURL) }"
                           :border="true"
                           icon="eye"
                           @click="showPreview()" />
      </template>
    </hm-input>
    <span v-if="isEmpty(internalValue.fileName)" :class="[ 'hm-input__file--button' ]" @click="onClickButton()">{{ $t('inputs.hmInputFile.selectFile') }}</span>
    <span v-else :class="[ 'hm-input__file--filename' ]" :title="internalValue.fileName" v-html="internalValue.fileName"></span>

    <modal v-if="preview" :hide-buttons="true" :title="`${$t('inputs.hmInputFile.preview')} (${label})`" @cancel="preview = false">
      <hm-card-inner :full-size="true">
        <hm-col cols="12" style="overflow:hidden;max-height:75vh;">
          <iframe v-if="!isEmpty(internalValue.fileName) && internalValue.fileName.toLowerCase().endsWith('.pdf')" :src="internalValue.fileURL" style="border: none;width:100%;height:75vh;"></iframe>
          <img v-else
               :src="internalValue.fileURL"
               :alt="internalValue.fileName"
               :title="internalValue.fileName"
               style="max-width:100%;max-height:75vh;width:auto;height:auto;margin-left: 50%;transform: translateX(-50%);padding:20px;">
        </hm-col>
      </hm-card-inner>
    </modal>
  </hm-col>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isEmpty, isNil } from 'lodash';

export default {
  name: 'HmInputFile',

  mixins: [HmInputMixin, GridMixin, HotelmeisterMixin],
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        fileName: null,
        fileURL: null,
      }),
    },
    url: {
      required: true,
      type: String,
      default: null,
    },
  },

  data: function () {
    return {
      preview: false,
    };
  },

  computed: {
    helperText: function () {
      if (!isNil(this.$parent.errors.first(this.name))) {
        return this.$parent.errors.first(this.name);
      } else {
        return this.help;
      }
    },
  },

  created: function () {
    this.$serviceBus.$on('shortcut.esc', () => {
      this.preview = false;
    });
  },

  methods: {
    showPreview: function () {
      this.preview = true;
    },
    onChangeFileUpload: function () {
      if (isEmpty(this.url)) {
        this.internalValue.file = this.$refs.file.files[0];
        this.internalValue.fileName = this.internalValue.file.name;
        return;
      }

      const file = this.$refs.file.files[0];

      const formData = new FormData();
      formData.append('file', file);

      this.axios.post(this.url,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then((response) => {
        this.internalValue = {
          ...response.data.data,
        };
      })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    deleteFile: function () {
      this.axios.delete(this.url)
        .then((response) => {
          this.internalValue = {
            fileName: null,
            fileURL: null,
          };
        })
        .catch((error) => {
        });
    },
    onClickButton() {
      this.$refs.file.$el.querySelector('input[type="file"]').click();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>

<style lang="scss">
  @import '~styles/import';

  .hm-input__file {
    &--file-set {
    }
    input[type='file']:after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      border-radius: 0.3rem;
      opacity: 1;
      pointer-events: none;
    }
    &--filename {
      position: absolute;
      top: 0.6rem + 0.9rem;
      left: 1rem;
      z-index: 2;
      pointer-events: none;
      max-width: calc(100% - 2 * 3.2rem - 1rem);
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &--button {
      position: absolute;
      top: 0.6rem;
      right: 0;
      z-index: 2;
      padding: 0.9rem 1rem 0.7rem;
      max-width: calc(100% - 2 * 3.2rem - 1rem);
      overflow: hidden;
      text-overflow: ellipsis;
      color: $white;
      background-color: $blue;
      transition: background 0.2s ease;
      border-top-right-radius: 0.3rem;
      border-bottom-right-radius: 0.3rem;
      &:hover {
        background: darken($blue, 10%);
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputFile.vue